import { Card, CardContent, Typography } from '@mui/material';

export function HistogramIcon() {
    return (
        <svg width="42" height="46" viewBox="0 0 42 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.75 36.418V7.66797H7V38.3346H35V36.418H8.75Z" fill="black" />
            <path d="M10.5 23H17.5V34.5H10.5V23Z" fill="black" />
            <path d="M19.25 11.5H26.25V34.5H19.25V11.5Z" fill="black" />
            <path d="M28 19.168H35V34.5013H28V19.168Z" fill="black" />
        </svg>

    )
}

export function QuestionIcon() {
    return (
        <svg width="49" height="52" viewBox="0 0 49 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.5 8.66797C15.5166 8.66797 8.16663 16.468 8.16663 26.0013C8.16663 35.5346 15.5166 43.3346 24.5 43.3346C33.4833 43.3346 40.8333 35.5346 40.8333 26.0013C40.8333 16.468 33.4833 8.66797 24.5 8.66797ZM26.3375 36.8346H22.2541V32.5013H26.3375V36.8346ZM30.625 26.218C29.8083 27.0846 28.9916 27.518 28.175 27.7346C26.95 28.6013 26.5416 28.168 26.5416 30.3346H22.4583C22.4583 26.0013 24.9083 24.7013 26.5416 23.8346C27.1541 23.618 27.5625 23.4013 27.9708 22.968C28.175 22.7513 28.5833 22.318 28.175 21.4513C27.7666 20.368 26.5416 19.2846 24.7041 19.2846C21.8458 19.2846 21.4375 21.8846 21.2333 22.5346L17.15 21.8846C17.3541 19.5013 19.1916 14.9513 24.5 14.9513C27.7666 14.9513 30.625 16.9013 31.85 19.718C32.6666 22.1013 32.2583 24.4846 30.625 26.218Z" fill="black" />
        </svg>

    )
}

export function UnlockIcon() {
    return (
        <svg width="37" height="40" viewBox="0 0 37 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.7917 18.3326V11.6659C10.7897 9.59936 11.4982 7.60572 12.7795 6.07206C14.0607 4.53839 15.8234 3.57412 17.7253 3.36643C19.6272 3.15874 21.5327 3.72245 23.0718 4.94813C24.6109 6.17382 25.6738 7.97402 26.0542 9.99928M7.70833 18.3326H29.2917C30.9945 18.3326 32.375 19.825 32.375 21.6659V33.3326C32.375 35.1736 30.9945 36.6659 29.2917 36.6659H7.70833C6.00546 36.6659 4.625 35.1736 4.625 33.3326V21.6659C4.625 19.825 6.00546 18.3326 7.70833 18.3326Z" stroke="#1E1E1E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}


export default function CardComponent({icon, heading, subHeading}: any) {
    return (
        <Card sx={{ width: "30%" }}>
            <CardContent style={{ textAlign: "left" }}>
                <div >{icon}</div>
                {heading}
                <Typography fontWeight={500} sx={{ color: 'text.secondary' }}>{subHeading}</Typography>
            </CardContent>
        </Card>
    );
}